

    <!-- <section style="background:#efefe9;">
        <div class="container">
            <div class="board">
                <app-header-wizard></app-header-wizard>
      
                <div class="tab-content">
                    <router-outlet></router-outlet>
                </div>
            </div>
      
            <pre>{{ formData | json }}</pre>
        </div>
      </section> -->


      <div class="row">
        <div class="col-lg-12">
          
               <router-outlet></router-outlet>
                <!--<pre>{{ formData | json }}</pre>-->
          
        </div>
      </div>
